"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSocketIoInstance = void 0;
var isValidSocketIoInstance = function (socketInstance) {
    if (!socketInstance)
        return false;
    return 'emit' in socketInstance;
};
exports.isValidSocketIoInstance = isValidSocketIoInstance;
